import { z } from 'zod';

const projectPath = z.string().trim();
const accountKeys = z.array(z.string()).min(1, 'Pick at least one account key.');

export const linkRepositorySchema = z.object({
  repoKey: z.string().min(1, 'Pick a repository.'),
  accountKeys,
  projectPath,
});
export type LinkRepositoryValues = z.infer<typeof linkRepositorySchema>;

export const editProjectSchema = z.object({ accountKeys, projectPath });
export type EditProjectValues = z.infer<typeof editProjectSchema>;

/** An empty path is the repository root, as `link` reads it. */
export function normalizeProjectPath(path: string): string {
  const trimmed = path.trim();
  return trimmed === '' ? '/' : trimmed;
}

/** The oRPC error code of a refused call (`CONFLICT`, `BAD_REQUEST`, …), or null. */
export function rpcErrorCode(err: unknown): string | null {
  if (typeof err !== 'object' || err === null || !('code' in err)) return null;
  return typeof err.code === 'string' ? err.code : null;
}

export function rpcErrorMessage(err: unknown, fallback: string): string {
  if (typeof err === 'object' && err !== null && 'message' in err && typeof err.message === 'string' && err.message) {
    return err.message;
  }
  return fallback;
}
